import axios from 'axios';

const createDocument = async ({ documentData }) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/documents`, documentData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response.data;
}

const updateDocument = async ({ documentId, documentData }) => {
  const response = await axios.put(`${process.env.REACT_APP_API_URL}/documents/${documentId}`, documentData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response.data;
}

const deleteDocument = async ({ documentId }) => {
  const response = await axios.delete(`${process.env.REACT_APP_API_URL}/documents/${documentId}`);

  return response.data;
}

const documentService = {
  createDocument,
  updateDocument,
  deleteDocument
}

export default documentService;
